import { Route, Routes } from 'react-router-dom';
import './App.css';
import NotFound from './pages/NotFound';
import DriverOutlets from './pages/Driver/DriverOutlets';
import DriverTracking from './pages/Driver/DriverTracking';
import AuthProvider from './context/AuthProvider';
import "react-datepicker/dist/react-datepicker.css";
import Login from './pages/Login';
import DriverHelper from './pages/Driver/DriverHelper';
import OutletSTO from './pages/Outlet/OutletSTO';

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path='/' element={<Login />} />
        
        {/* Driver Helper Routes */}
        <Route path='/driver-helper' element={<DriverHelper />} />
        <Route path='/driver-outlets' element={<DriverOutlets />} />
        <Route path='/driver-tracking' element={<DriverTracking />} />
        
        {/* Outlet Routes */}
        <Route path='/outlet-sto' element={<OutletSTO />} />
        
        <Route path='*' element={<NotFound />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
